import { render, staticRenderFns } from "./SimpleIndicatorCard.vue?vue&type=template&id=3cd4dbca&"
import script from "./SimpleIndicatorCard.vue?vue&type=script&lang=js&"
export * from "./SimpleIndicatorCard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleIndicatorCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports